import { render, staticRenderFns } from "./transdetail.vue?vue&type=template&id=2143903b&"
import script from "./transdetail.vue?vue&type=script&lang=js&"
export * from "./transdetail.vue?vue&type=script&lang=js&"
import style0 from "./transdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports